import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export interface ElectronicSignatureConfig {
  eSignatureEnabled: boolean;
  eSignatureNotaryRequired: boolean;
  eSignatureConsentAt: string | null;
  eSignatureConsentByUserId: string | null;
  eSignatureConsentByUser: {
    id: string;
    fullName: string;
    email: string;
  } | null;
  eSignatureTokenTtlHours: number;
  authorizedSignerUserIds?: string[];
}

export const ELECTRONIC_SIGNATURE_QUERY_KEY = ['settings', 'electronic-signature'] as const;

export function useElectronicSignatureConfig() {
  return useQuery({
    queryKey: ELECTRONIC_SIGNATURE_QUERY_KEY,
    queryFn: () =>
      apiClient.get<ElectronicSignatureConfig>('/settings/electronic-signature'),
  });
}
